import React from "react"
import { css, keyframes } from "emotion"
import type { Notification } from "../types"

let SlideLeft = keyframes`
	0% {
		transform: translate3D(4em, 0, 0);
		opacity: 0.7;
	}
	10% {
		transform: translate3D(0, 0, 0);
		opacity: 1;
	}
	90% {
		transform: translate3D(0, 0, 0);
		opacity: 1;
	}
	100% {
		transform: translate3D(4em, 0, 0);
		opacity: 0;
	}
`

let columnClassName = css`
	display: flex;
	flex-direction: column;

	&:not(:last-child) {
		margin-right: 15px;
	}
`

let rowClassName = css`
	width: 270px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
	font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI",
		Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
		"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	color: #2a3632;

	&:last-child {
		opacity: 50%;
	}
`

function getCurrentUrl() {
	return window.location.href.replace("www.", "").replace("/", "")
}

export interface ToastProps {
	notification: Notification
	onGoToThread: (threadIndex: number) => void
}

export default function Toast(props: ToastProps) {
	function handleGoToThread() {
		if (
			props.notification.url.charAt(0) === "/" ||
			props.notification.url === getCurrentUrl()
		) {
			window.scrollTo(0, props.notification.threadY - 100)
			props.onGoToThread(props.notification.threadIndex)
		} else {
			// window.location.replace(`http://${url}`)
			// TODO need a way to scroll to the right thread, probably with query param
		}
	}

	return (
		<div
			onClick={handleGoToThread}
			className={css`
				cursor: pointer;
				background: white;
				height: 75px;
				width: 350px;
				border-radius: 5px;
				z-index: 1000004;
				display: flex;
				flex-direction: row;
				align-items: center;
				box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
				box-sizing: border-box;
				padding: 0.75em;
				margin-bottom: 0.75em;
				border: 1px solid #eaebeb;
				animation: ${SlideLeft} 4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
			`}
		>
			<div className={columnClassName}>
				<img
					src={props.notification.avatar}
					className={css`
						width: 40px;
						height: 40px;
						border-radius: 50%;
					`}
				/>
			</div>
			<div className={columnClassName}>
				<div className={rowClassName}>{props.notification.type}</div>
				<div className={rowClassName}>
					{`${props.notification.author}: ${props.notification.text}`}
				</div>
				<div className={rowClassName}>{props.notification.url}</div>
			</div>
		</div>
	)
}
